<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <!-- Options de validation -->
          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Nbr page</label>
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
            </b-form-group>
          </b-col>

          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Année</label>
              <b-form-select id="yearSelect" v-model="currentYear" size="sm" :options="yearOptions"
                class="w-50" />
            </b-form-group>
          </b-col>

          <b-col md="4" sm="4" class="my-1">
            <b-form-group label="Statut" label-cols-sm="3" label-align-sm="right" label-size="sm" class="mb-0">
              <v-select v-model="selectedStatus" multiple label="title" :options="optionStatus"
                :reduce="option => option.value" />
            </b-form-group>
          </b-col>

          <b-col md="4" class="my-1">
            <b-form-group label="Filtrer" label-cols-sm="3" label-align-sm="right" label-size="sm"
              label-for="filterInput" class="mb-0">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Rechercher..."   @input="fetchUserObjectives"/>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Effacer</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
<!-- :per-page="perPage" :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn"  -->
          <b-col cols="12" class="mt-2">
            <b-table striped hover responsive  :items="userObjectives"
              :fields="tableColumns"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     :sort-direction="sortDirection"
             @filtered="onFiltered">
              <template #cell(user)="data">
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar size="40" variant="light-primary" class="badge-minimal" badge-variant="success">
                      {{ getUserInitials(data.item.users) }}
                    </b-avatar>
                  </template>
                  <span class="font-weight-bold d-block text-nowrap">{{ data.item.users.lastName + ' ' +
                    data.item.users.firstName
                    }}</span>
                  <small class="text-muted">{{ data.item.users.mail }}</small>
                </b-media>
              </template>

              <template #cell(fonction)="data">
                <span v-if="data.item.users.fonction" class="font-weight-bold d-block text-nowrap">{{ data.item.users.fonction }}</span>

                  <small class="text-muted" v-if="data.item.users.services.name">{{ data.item.users.services.name  }}</small>

              </template>
              <template #cell(status)="data">
                <b-badge :variant="statusVariants[data.item.status]">{{ statusLabels[data.item.status] }}</b-badge>
              </template>

              <template #cell(nextStep)="data">
                <span class="text-primary">
                  {{
                    data.item.status === 'PROPOSE'
                        ? (data.item.dateObjectifPrevu ? "Validation/Rejet par manager N°1 !" : "Définir la date de la rencontre")
                        : nextStepLabels[data.item.status]
                  }}
                </span>

              </template>

              <template #cell(actions)="data">
                <div class="text-nowrap">
                  <feather-icon :id="`objective_print-row-${data.item.id}-preview-icon`" icon="EyeIcon" size="16"
                    class="mx-1" @click="$router.push({ name: 'objectif_print', params: { id: data.item.id, isRapport: 0 } })" />
                  <b-tooltip title="Detail Objectif" :target="`objective_print-row-${data.item.id}-preview-icon`" />


                  <feather-icon
                    v-if="canEditObjective(data.item)"
                    :id="iconId"
                    :icon="data.item.dateObjectifPrevu ? 'EditIcon' : 'CalendarIcon'"
                    size="16"
                    class="mx-1"
                    @click="handleClick(data.item)"
                  />
                  <b-tooltip :title="tooltipTitle(data.item)" :target="iconId" />


                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card-body>
      <b-col cols="12">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
          class="my-1" />
      </b-col>
    </b-card>



    <b-modal id="modal-sm" v-model="isModalActive" modal-class="modal-primary" ok-only ok-title="OK" centered size="sm"
      :title="'Date'" @ok="confirmDateObjectif">
      <b-row>
        <b-col md="12">
          <b-form-group>
            <h5>Date pour la validation des Objectifs</h5>
            <!-- <flat-pickr v-model="inlineDate" class="form-control"
                :config="{ enableTime: true, dateFormat: 'd-m-y H:i' }" /> -->
            <flat-pickr v-model="inlineDate" class="form-control" :config="{
              inline: true,
              enableTime: true,
              dateFormat: 'd-m-y H:i',
              minDate: new Date(),
              maxDate: new Date().fp_incr(14),
              defaultDate: new Date(),
              locale: French
            }" />

          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>



</template>

<script>
import { BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BFormCheckbox } from 'bootstrap-vue'
import { getUserObjectivesAll,updateDateUserObjective } from '@/services/UserObjectiveService'
import vSelect from 'vue-select'
import { allYears } from '@/services/YearsService';
import flatPickr from 'vue-flatpickr-component'
import flatpickr from 'flatpickr';
flatpickr.localize(French);
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getJsonFromStorage } from "@/util/storageUtils";
import { getSetting } from "@/services/SettingService";
import {French} from "flatpickr/dist/l10n/fr";

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    vSelect,
    flatPickr,
    //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {

      perPage: 10,
      pageOptions: [3, 5, 10, 25, 50, 100, 200],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      // tableColumns: [
      //   { key: 'user', label: 'Nom Prénom(s)', sortable: true },
      //   { key: 'fonction', label: 'Fonction', sortable: true },
      //   { key: 'services', label: 'Services', sortable: true },
      //   { key: 'status', label: 'Status', sortable: true },
      //   { key: 'actions', label: 'Actions' },
      // ],
      userObjectives: [],
      currentYear: null,
      years: [],
      // user:'',
      selectedStatus: [],
      statusLabels: {
        PROPOSE: "Proposé",
        VALIDE_HIERARCHY_1: "Validé par manager N°1",
        VALIDE_HIERARCHY_2: "Validé manager N°2",
        REJETE: "Rejeté",
        VALIDE_COLLABORATEUR: "Validation finale",
        TRANSMIT_HIERARCHY_2: "Transmis manager N°2",
      },

      nextStepLabels: {
        PROPOSE: "Validation/Rejet par manager N°1 !",
        VALIDE_HIERARCHY_1: "Validation par collaborateur !",
        VALIDE_HIERARCHY_2: "Validation par collaborateur !",
        REJETE: "Correction des objectifs !",
        VALIDE_COLLABORATEUR: "-",
        TRANSMIT_HIERARCHY_2: "Validation par manager N+2 !",
      },

      optionStatus: [
        { value: 'PROPOSE', title: 'Proposé' },
        { value: 'VALIDE_HIERARCHY_1', title: 'Validé par manager N°1' },
        { value: 'VALIDE_HIERARCHY_2', title: 'Validé manager N°2' },
        { value: 'REJETE', title: 'Rejeté' },
        { value: 'VALIDE_COLLABORATEUR', title: 'Validation finale' },
        { value: 'TRANSMIT_HIERARCHY_2', title: 'Transmis manager N°2' },
      ],

      statusVariants: {
        PROPOSE: "primary",
        VALIDE_HIERARCHY_1: "success",
        VALIDE_HIERARCHY_2: "success",
        REJETE: "danger",
        VALIDE_COLLABORATEUR: "success",
        TRANSMIT_HIERARCHY_2: "warning",
      },
      isModalActive:false,
      inlineDate:null,
      userObjectivesDate:{},
      userData:null,
    }
  },
  computed: {
    French() {
      return French
    },
     yearOptions() {
    return this.years.map(y => ({
      value: y.year,
      text: y.year.toString()
    }));
  },
    tableColumns() {

      const columns = [
        { key: 'user', label: 'Nom Prénom(s)', sortable: true },
        { key: 'fonction', label: 'Fonction', sortable: true },
        // { key: 'services', label: 'Services', sortable: true },
        { key: 'status', label: 'Statut', sortable: true },
        { key: 'nextStep', label: 'Prochaine étape', sortable: true },
        { key: 'actions', label: 'Actions' },
      ]
      if (this.userObjectives.services) {
        columns.push({ key: 'services', label: 'Services', sortable: true })
      }
      return columns
    },
    sortOptions() {
      return this.tableColumns.filter(f => f.sortable).map(f => ({ text: f.label, value: f.key }))
    },
    iconId(data) {

      return `objective-row-${data.id}-preview-icon`;
    },

  },

  methods: {
    tooltipTitle(data) {
      return data.dateObjectifPrevu ? "Éditer Objectif" : "Définir la date de validation";
    },
     showToast (message, color, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Notification',
          icon: icon,
          timeout: 8000,
          text: message,
          variant: color,
        },
      });
    },
    handleClick(data) {

      this.userObjectivesDate = data;

      if (data.dateObjectifPrevu) {
        this.$router.push({ name: 'objectif', query: { id: data.id, year: this.currentYear } });
      } else {
        this.dateObjectif();
      }
    },
    confirmDateObjectif() {
      this.userObjectivesDate.dateObjectifPrevu=this.inlineDate;
      updateDateUserObjective(this.userObjectivesDate.id ,this.userData.id,this.userObjectivesDate).then(result=>{
        if (result.dateObjectifPrevu) {
          this.showToast("Date enregistrée avec succès", "success", "BellIcon");
        } else {
          this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
        }

      })
      .catch(error => {
        this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");

        console.error("Erreur lors de la récupération des données :", error)

      });


    },
    dateObjectif() {
      this.isModalActive = true;
    },
    getUserInitials(user) {
      const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : ''
      const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : ''
      return `${lastInitial}${firstInitial}`
    },
    async fetchUserObjectives() {
      try {
        this.userData = getJsonFromStorage('userData')
        if (this.userData && this.currentYear) {

          const response = await getUserObjectivesAll(this.currentPage - 1, this.perPage, this.userData.id, this.selectedStatus, this.currentYear,this.filter,false)


          if (response ) {
            this.userObjectives = response.userObjectives
            this.totalRows = response.count

          }

        }

      } catch (error) {
        console.error('Error fetching user objectives:', error)
      }
    },
    canEditObjective(userObjective) {

      const status = userObjective.status;


      switch (status) {
        case 'PROPOSE':

          return true;
        case 'VALIDE_HIERARCHY_1':

          return true;
        case 'VALIDE_HIERARCHY_2':
          return this.isHierarchyN2(userObjective);

        case 'REJETE':

          return true;
        case 'VALIDE_COLLABORATEUR':
          return false;
        case 'TRANSMIT_HIERARCHY_2':
          return true;
        default:
          return false;
      }


    },
    isHierarchyN2(userObjective) {
      if (userObjective && userObjective.signatureObjective) {
        const userData = getJsonFromStorage('userData')

        const userSignatureObjective = userObjective.signatureObjective.find(sigObj => sigObj.users.id === userData.id);
        return userSignatureObjective && userSignatureObjective.hierarchyN === 2;

      }
    },

    async getAllYears() {
      const response = await allYears();
      this.years = response;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
  watch: {
    userObjective(newVal) {
      if (newVal) {
        this.canEditObjective();
      }
    },
    selectedStatus(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUserObjectives()
    },

    currentYear(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUserObjectives()
    },
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUserObjectives()
    },
    perPage(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUserObjectives()
    },
  },
  mounted() {
    this.getAllYears()
    this.fetchUserObjectives()

    // Gilchrist ce 10/09/2025
    getSetting()
        .then((response) => {
          this.currentYear = response.yearObjective.year;
        })
        .catch((error) => {
          console.error('Error fetching settings:', error);
          this.currentYear = { year: new Date().getFullYear() }
        });
    // Fin Gilchrist
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>
